import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const COUNTRIES_WITHOUT_VAT_TEXT = [MarketCountryCode.JP]
